module.exports = __webpack_public_path__ + "img/foodbeverage_icon_old.a16c7a8a.svg";